import React, {Component} from 'react';
import {Htmldiff} from "../htmldiff";
import BaseComponent from "../../../../base/BaseComponent";
import moment from "moment";

class History extends BaseComponent {

    static defaultProps = {
        dataType: "website"
    };

    state = {
        list : [],
    };

    componentDidMount() {
        let editorId = this.props.id;
        let dataType = this.props.dataType;
        this.getHistoryData(dataType,editorId);
    }

    getHistoryData(dataType,editorId){
        if(editorId){
            let url = "/cm-sites-pms/website/news/getWebNewsHistory";
            let body = {webNewsId:editorId};
            if(dataType === "story"){
                url = "/cm-sites-pms/story/getStoryHistory";
                body = {storyId:editorId};
            }
            if(dataType === "rmapp"){
                url = "/cm-sites-mmp/mf/getMediaFusionHistory";
                body = {mediaFusionId: editorId};
            }
            this.request({
                url, body,
                callBack: (list)=>{
                    list && list.map(item=>{
                        let createTime = item.createTime ? moment(item.createTime).format('YYYY-MM-DD HH:mm:ss') : null;
                        item.showName = `${item.operator} ${createTime}`;
                    });
                    this.setState({list})
                }
            })
        }
    }

    render() {
        let props = {
            dataKey: "id",
            dataValue: "showName",
            leftDataSource: this.state.list,
            rightDataSource: this.state.list,
            leftContent: (this.state.list && this.state.list.length > 0 && this.state.list[0].content) ? this.state.list[0].content:"",
            rightContent: (this.state.list && this.state.list.length > 0 && this.state.list[0].content) ? this.state.list[0].content:"",
            leftSelectOnChange:(id)=>{
                return new Promise((resolve, reject) => {
                    let item = this.state.list.find(item=>item.id === id);
                    resolve(item.content);
                })
            },
            rightSelectOnChange:(id)=>{
                return new Promise((resolve, reject) => {
                    let item = this.state.list.find(item=>item.id === id);
                    resolve(item.content);
                })
            }
        };
        return (
            <Htmldiff {...props} />
        );
    }

}

export default History;